<script>
  import { createComponent } from '@mpxjs/core'
  import store from '@/store'
  import dayjs from 'dayjs'
  import duration from 'dayjs/plugin/duration'
  dayjs.extend(duration)

  createComponent({
    props: {
      type: {
        type: String,
        default: 'popup' // popup中样式较drawer小一些
      }
    },
    data: {
      hlStyle: {
        color: '#FF6400',
        fontFamily: 'Barlow Semi Condensed',
        fontSize: '18px'
      },
    },
    computed: {
      ...store.mapState({
        scrambleTicketInfo: 'order.scramble_ticket_info'
      }),
      contents() {
        const _data = {
          drawer_no: {
            pic: 'https://ut-static.udache.com/webx/sfc/pDkbN4YniBziu9B0lRmb1_clipboard_image_1697710831736.png',
            title: '即将{{大量放票}}，取消需重新排队',
          },
          drawer_yes: {
            pic: 'https://ut-static.udache.com/webx/sfc/ofR9ehweMk2o0lAoNwq_M_clipboard_image_1697710840073.png',
            title: '再等等，正在为你加速抢票',
          },
          popup_no: {
            pic: 'https://ut-static.udache.com/webx/sfc/N4wSDUrMh4KA2m33SC3Lc_clipboard_image_1697710848004.png',
            title: '即将大量放票',
          },
          popup_yes: {
            pic: 'https://ut-static.udache.com/webx/sfc/WVAukmG6_O_f29kFLD7ax_clipboard_image_1697710856259.png',
            title: '正在为你加速抢票',
          },
        }
        const now = dayjs()
        const endTime = dayjs(this.scrambleTicketInfo?.qorder_end_time) // 抢票截止时间
        const mainTrain = this.scrambleTicketInfo.main_train_info
        const allTrainStartTimes = [
          ...this.scrambleTicketInfo.train_detail_list.map(({start_date, start_time}) => `${start_date} ${start_time}`),
          `${mainTrain.start_date} ${mainTrain.start_time}`
        ]
        const lastStartTrainTime = allTrainStartTimes.map(_t => dayjs(_t).valueOf()).sort((a,b)=>b-a)[0]
        const alotTicketTime = dayjs(lastStartTrainTime).subtract(2, 'd') // 大量放票时间
        const diff = now.diff(alotTicketTime)
        const noTicketStatus = diff < 0 // 是不是没放票
        const showTime = noTicketStatus ? alotTicketTime : endTime// 要展示的时间
        const _diff = showTime.diff(now)
        const _d = dayjs.duration(_diff);
        const diffRet = _diff>0 ? `{{${_d.days()}}} 天 {{${_d.hours()}}} 时 {{${_d.minutes()}}} 分` : '' // 距离结束
        const _key = `${this.type}_${noTicketStatus ? 'no' : 'yes'}`

        return {
          ..._data[_key],
          subTitle: diffRet ? ((noTicketStatus ? '距离下一个放票点 ' : '距离结束 ') + diffRet) : '',
          noTicketStatus,
          showTime: showTime.format('MM-DD HH:mm') + (noTicketStatus ? '' : '停止'),
        }
      },
    },
  })
</script>

<template>
  <view wx:class="container {{type}}">
    <view class="title">
      <hl-text text="{{contents.title}}" />
    </view>
    <view class="sub-title">
      <hl-text hlStyle="{{hlStyle}}" text="{{contents.subTitle}}" />
    </view>
    <image class="chart" mode="widthFix" src="{{contents.pic}}"></image>
    <view wx:class="chart-text {{contents.noTicketStatus ? 'no' : 'yes'}}">
      <text class="time-start">当前时间</text>
      <text class="time-end">{{ contents.showTime }}</text>
    </view>
  </view>
</template>

<style lang="stylus" scoped>
  .container
    width 375px
    max-width 100%
    box-sizing border-box
    line-height 1
    font-weight normal
    padding 29px 20px 0
    .title
      font-family PingFangSC-Semibold
      font-size 22px
    .sub-title
      font-family PingFangSC-Medium
      font-size 16px
      margin 48px 0 43px
    .chart
      width 100%
    .chart-text
      @extend .flex-center
      justify-content space-between
      position relative
      height 66px
      .time-start, .time-end
        font-family PingFangSC-Regular
        font-size 12px
        color #666666
        position absolute
        top 8px
      .time-start
        left 31.49%
        transform translateX(-50%)
      .time-end
        right 24.18%
        transform translateX(50%)
    .yes>.time-start, .no>.time-end
      font-family PingFangSC-Medium
      color #333
    .yes
      .time-start
        left 24.92%
      .time-end
        right 0
        transform none
  .container.popup
    .sub-title
      margin 12px 0 32px
    .chart-text
      height auto
    .time-start
      left 17.46%
    .time-end
      right 20.68%
    .yes
      .time-start
        left 21.69%
      .time-end
        right 0
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'hl-text': '@/components/hl-text'
    }
  }
</script>
